


import { PortableText } from '@portabletext/react';
import { Link } from 'react-router-dom';
import ParallaxEffect from "../ParallaxEffect";
import AnimateIn from '../general/AnimateIn';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';

const HomeOverview = () => {
  const images = useImages();

  if (!Array.isArray(images) || !images.length) {
    return <div></div>;
  }

  // Helper function to find an image by title
  const getImageByTitle = (title) => {
    return images.find((image) => image.title === title);
  };

  // Fetch specific images by their titles

  const heroimg = getImageByTitle('Home Overview Section');
  const secIcon = getImageByTitle('sec-icon');



  return (
    <>
      <section id="parallax-grp" className="section-padding home-hero-section" >
        <div className="container ">
          <div className="row">
            <div className="col-lg-5  order-2 order-md-1">
              <AnimateIn type="left" >
                <div className="home-hero-img text-center">
                  {heroimg && (

                    <img
                      src={urlFor(heroimg.file.asset)}
                      alt={heroimg.altText || 'Sanity Image'}
                    />

                  )}


                </div>
              </AnimateIn>
            </div>
            <div className="col-lg-7 col-md-12 order-1 order-md-2 d-flex  justify-content-center">
              <AnimateIn type="right" >
                <div className="row">
                  <div className="col-12 col-md-8 col-lg-8">
                    <div className="home-hero-content pt-3 ">

                      <div className="sec-title ">
                        <div className="px-2  d-flex align-items-center" >
                          <div>  {heroimg.Sectitle} </div>
                          <div className="px-2 sec-icon">
                            {secIcon && (

                              <img
                                src={urlFor(secIcon.file.asset)}
                                alt={secIcon.altText || 'Sanity Image'}
                              />

                            )}
                          </div>
                        </div>
                      </div>
                      <div className="home-title pt-3">
                        <span className="text-gradient" >
                          {heroimg.sectionTitle}
                        </span>
                      </div>
                      <div className="section-content">
                        {/* Render Portable Text content */}
                        {heroimg.content && (
                          <PortableText
                            value={heroimg.content}
                            components={{
                              block: {
                                normal: ({ children }) => <p>{children}</p>,
                                h1: ({ children }) => <h1>{children}</h1>,
                                h2: ({ children }) => <h2>{children}</h2>,
                              },
                              marks: {
                                link: ({ children, value }) => (
                                  <a
                                    href={value.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                  >
                                    {children}
                                  </a>
                                ),
                              },
                            }}
                          />
                        )}
                      </div>
                      <Link to="/social-automation" className="panacea-arrow-link">
                        {heroimg.btnlabel} <i className='bx bxs-right-top-arrow-circle'></i>
                      </Link>
                    </div>
                  </div>
                  <div className="col-0 col-md-4 col-lg-4 d-desktop">
                    <ParallaxEffect />
                  </div>
                </div>
              </AnimateIn>
            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default HomeOverview;
